import { render, staticRenderFns } from "./plan-detail.vue?vue&type=template&id=456db167&scoped=true"
import script from "./plan-detail.vue?vue&type=script&lang=js"
export * from "./plan-detail.vue?vue&type=script&lang=js"
import style0 from "./plan-detail.vue?vue&type=style&index=0&id=456db167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456db167",
  null
  
)

export default component.exports